import gql from "graphql-tag";

export const PRIZE_ELIGIBILITY_QUERY = gql`
query prizeEligibilityQuery($date: Date!, $userId: ID) {
  userPrizeWeeklyEligibility(anchorDate: $date, userId: $userId) {
    qualifiedForPrize
    dayBreakdown {
      date
      isRestDay
      workoutImage
      loggedNutrition
      loggedWorkout
      greenDay
    }
  }
}
`;